import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  ADD_PRODUCT,
  ADD_SUB_PRODUCT,
  ADD_SUB_PRODUCT_ERROR,
} from "../ActionTypes/productVActionTypes";

const initialState = {
  loading: false,
  products: [], // garde les produits avec leurs sous-produits
  error: "",
};

const productVReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCTS_REQUEST:
      return { ...state, loading: true };

    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload, // payload contient déjà produits + sousProduits
        error: "",
      };

    case FETCH_PRODUCTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case ADD_PRODUCT:
      return {
        ...state,
        products: [...state.products, action.payload],
      };

    case ADD_SUB_PRODUCT:
      return {
        ...state,
        products: state.products.map((prod) =>
          prod._id === action.payload.productId
            ? { ...prod, subProducts: [...prod.subProducts, action.payload.subProduct] }
            : prod
        ),
      };

    case ADD_SUB_PRODUCT_ERROR:
      console.error("Erreur sous-produit :", action.payload);
      return state;

    default:
      return state;
  }
};

export default productVReducer;
